﻿import * as React from 'react';
import { Col } from 'react-bootstrap';
import { Translate } from '../../../../../../shared/LanguageService';
import PhotographerImpersonationDropdown from '../../PhotographerImpersonationDropdown';
import { AuthenticatedUser } from '../../../../../../shared/types';

type SE360PhotographerBookingInfoProps = {
    user: AuthenticatedUser;
    photographerId: number;
    photographerName: string;
    navigateTo: (path: string) => void;
};

function SE360PhotographerBookingInfo({
    user,
    photographerId,
    photographerName,
    navigateTo
}: SE360PhotographerBookingInfoProps) {
    return (
        <Col sm={6}>
            <dt>{Translate('view-order/basic-order-info/titles/photographer')}</dt>
            <dd>
                <PhotographerImpersonationDropdown
                    user={user}
                    name={photographerName}
                    id={photographerId}
                    navigateTo={navigateTo}
                />
            </dd>
        </Col>
    );
}

export default SE360PhotographerBookingInfo;
